import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterNoApply'
})
export class FilterNoApplyPipe implements PipeTransform {
  transform(columns: any[]): any[] {
    if (!columns) return [];
    return columns.filter(col => col.name !== 'NO_APPLY');
  }
}